module.exports = __webpack_public_path__ + "img/data_source.aac649de.png";